export enum ConfigType {
    Field = "fields",
    Group = "groups",
    Section = "sections",
    Option = "options",
}

export enum ConfigModuleName {
    Core = "core",
    Operation = "operation",
}

export enum CoreConfigModuleName {
    MaxIdleMinutes = "CORE_MAX_IDLE_MINUTES",
    IdleCountdownTimeSeconds = "CORE_IDLE_COUNTDOWN_TIME_SECONDS",
    PatientExtraDataValidMonths = "CORE_PATIENT_EXTRA_DATA_VALID_MONTHS",
    CopyPersonIdToClipboardFormat = "CORE_COPY_PERSONID_TO_CLIPBOARD_FORMAT",
}

export enum OperationConfigModuleName {
    Anmalan = "OPERATION_ANMALAN",
    OperationVeckooversikt = "OPERATION_VECKOOVERSIKT",
    Journal = "OPERATION_JOURNAL",
    JournalOperationsuppgifter = "OPERATION_JOURNAL_OPERATIONSUPPGIFTER",
    JournalTider = "OPERATION_JOURNAL_TIDER",
    JournalPersonal = "OPERATION_JOURNAL_PERSONAL",
    JournalAnestesi = "OPERATION_JOURNAL_ANESTESI",
    JournalMaterial = "OPERATION_JOURNAL_MATERIAL",
    OperationJournalPatientdata = "OPERATION_JOURNAL_PATIENTDATA",
    JournalPostoperativOvervakning = "OPERATION_JOURNAL_POSTOPERATIV_OVERVAKNING",
    JournalStralningsregistrering = "OPERATION_JOURNAL_STRALNINGSREGISTRERING",
    JournalExternStralningsregistreringUrl = "OPERATION_JOURNAL_EXTERN_STRALNINGSREGISTRERING_URL",
    Preanestesibedomning = "OPERATION_PREANESTESIBEDOMNING",
    AnmalanStatuses = "OPERATION_ANMALAN_STATUSES",
    AnmalanDefaultStatus = "OPERATION_ANMALAN_DEFAULT_STATUS",
    OperationskoordineringDefaultFilter = "OPERATION_OPERATIONSKOORDINERING_DEFAULT_FILTER",
    OperationsoversiktDefaultFilter = "OPERATION_OPERATIONSVERSIKT_DEFAULT_FILTER",
    KalenderDetaljinfo = "OPERATION_KALENDER_DETALJINFO",
    PagaendeOperationDetaljinfo = "OPERATION_PAGAENDE_OPERATION_DETALJINFO",
}

export type ConfigModuleForm = {
    maxIdleMinutes?: number;
    [ConfigType.Field]?: {
        [key: string]: {
            visible?: boolean;
            required?: boolean;
        };
    };
    [ConfigType.Section]?: {
        [key: string]: {
            visible?: boolean;
        };
    };
    [ConfigType.Group]?: {
        [key: string]: {
            visible?: boolean;
        };
    };
    [ConfigType.Option]?: {
        [key: string]: any;
    };
};

export type ConfigSubModuleName = keyof typeof CoreConfigModuleName | keyof typeof OperationConfigModuleName;

export type Config = {
    [key in ConfigSubModuleName]: string | number | boolean | ConfigModuleForm;
};

export const CONFIG_PROVIDE_NAME = "configNames";
